import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useIsMobile from "../../hooks/useIsMobile";
import { isRepoAgent, isRepoUser } from "../../utils/permissions";
import repoAdminService from "../../services/repoAdmin.service";
import AgencyWelcomeBrand from "./AgencyWelcomeBrand";
import NotificationPanel from "./NotificationPanel";
import WorkModeToggle from "./WorkModeToggle";
import OfflineSyncStatus from "./OfflineSyncStatus";
import "../../styles/repo-panel-header.css";

function formatPlanExpiry(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export default function RepoPanelHeader() {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const [planExpiryLabel, setPlanExpiryLabel] = useState("");

  const name = auth?.user?.name || "User";
  const role = auth?.user?.role || "";

  useEffect(() => {
    if (!auth?.token || !isRepoUser(role)) {
      setPlanExpiryLabel("");
      return undefined;
    }
    let cancelled = false;
    repoAdminService
      .getSubscription(auth.token)
      .then((res) => {
        if (cancelled) return;
        const expiresAt = res?.data?.subscription?.expiresAt;
        setPlanExpiryLabel(formatPlanExpiry(expiresAt));
      })
      .catch(() => {
        if (!cancelled) setPlanExpiryLabel("");
      });
    return () => {
      cancelled = true;
    };
  }, [auth?.token, role]);

  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  if (!isRepoUser(role)) {
    return null;
  }

  const isFindVehiclesRoute = location.pathname.startsWith("/find-vehicles");
  const hideFieldUserMobileChrome =
    isMobile && isRepoAgent(role) && isFindVehiclesRoute;

  return (
    <div
      className={`repo-panel-chrome${
        hideFieldUserMobileChrome ? " repo-panel-chrome--fv-field-mobile" : ""
      }`}
    >
      <div className="repo-header-agency" aria-label="Agency">
        <AgencyWelcomeBrand className="agency-welcome--header" />
      </div>

      <header className="repo-admin-bar">
        <div className="repo-admin-bar-left">
          <h1 className="repo-greeting">
            Hi, <span className="repo-greeting-name">{name}</span>
          </h1>
          {planExpiryLabel ? (
            <button
              type="button"
              className="repo-plan-expiry"
              onClick={() => navigate("/plans")}
            >
              <span className="repo-plan-expiry-label">Alert Plan Expiry Date:</span>
              <span className="repo-plan-expiry-value">{planExpiryLabel}</span>
            </button>
          ) : null}
        </div>

        <div className="repo-admin-bar-right">
          <WorkModeToggle variant="header" />
          <NotificationPanel />
          <button
            type="button"
            className="repo-logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </header>
      <OfflineSyncStatus />
    </div>
  );
}
